import React, { useLayoutEffect, useRef } from "react";
import { NavContainer } from "./NavStyles";
const Nav = ({ align = "start", direction = "row", className, setHeight, width, children, }) => {
    const ref = useRef(null);
    useLayoutEffect(() => {
        if (ref.current && setHeight) {
            setHeight(ref.current.offsetHeight);
        }
    }, [ref, setHeight]);
    return (React.createElement(NavContainer, { align: align, direction: direction, className: className, ref: ref, navWidth: width }, children));
};
export default Nav;
//# sourceMappingURL=Nav.js.map